import { Component } from '@angular/core';

@Component({
    selector: 'clinical-report',
    template: '<router-outlet></router-outlet>',
    standalone: false
})
export class ClinicalReportComponent {}
